'use client'

import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';

export default function FadeIn({ children }: { children: React.ReactNode }) {
    const [key, setKey] = useState(0);
    const pathname = usePathname();

    useEffect(() => {
        setKey(prevKey => prevKey + 1);
    }, [pathname]);

    return (
        <motion.div
            key={key}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            {children}
        </motion.div>
    );
}
